import { useEffect, useState } from "react";

import useAppStore from "../../../store/AppStore";
import { useNavigate } from "react-router";
import { EmployeeItemData } from "./core/_model";
import { ActionsKey } from "../../../common/models/Actions";
import { deleteEmployeeById, getAllStaff } from "./core/_request";
import { useEmployeeListState, useEmployeeStore } from "./store/EmployeeStore";
import { ColumnItem } from "../../../common/models/table";
import { Loader } from "../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { Avatar, Tag } from "antd";
import { API_URLs } from "../../../utilities/API_URLs";
import { UserOutlined } from "@ant-design/icons";

export const EmployeeList = () => {
  const { activeMenu } = useAppStore();
  const navigate = useNavigate();
  const { employeeList, setEmployeeList, totalItems } = useEmployeeStore();
  const { pageState, setPageState, resetPageState } = useEmployeeListState();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "image",
      title: "",
      dataIndex: "image",
      show: true,
      render: (state: any) => {
        return (
          <div className="">
            <Avatar
              shape="square"
              {...(state
                ? {
                    src: state?.contentUrl,
                  }
                : {
                    icon: <UserOutlined />,
                  })}
            />
          </div>
        );
      },
    },
    {
      key: "registrationNumber",
      title: "Matricule",
      dataIndex: "registrationNumber",
      searchType: "text",
      show: true,
    },
    {
      key: "email",
      title: "Adresse mail",
      searchType: "text",
      dataIndex: "email",
      show: true,
    },
    {
      key: "fullname",
      title: "Nom & Prénom",
      searchType: "text",
      dataIndex: "fullname",
      show: true,
    },
    {
      key: "staffPost",
      title: "Poste",
      searchType: "select",
      dataIndex: "staffPost",
      searchKey: "staffPost.id",
      show: true,
      selectUri: API_URLs.staffPost.getStaffPostSelect,
      render: (state: any) => {
        return (
          <div className="">
            {state?.map((post: any) => (
              <Tag>{post?.name}</Tag>
            ))}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchStaff(pageState);
  }, [pageState]);

  const fetchStaff = async (params?: any) => {
    try {
      setIsLoading(true);

      const res = await getAllStaff(params);
      if (res?.status === HttpStatusCode.Ok) {
        setEmployeeList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteEmployeeById = async (Employee: EmployeeItemData) => {
    await deleteEmployeeById(Employee?.id?.toString());
    fetchStaff();
  };
  const onActionClick = (employee: EmployeeItemData, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteEmployeeById(employee);
    } else if (action === "read") {
      navigate(`detail/${employee?.id}`);
    } else if (action === "update") {
      navigate(`edit/${employee?.id}`);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <TitleHeader title={activeMenu?.title ?? ""} isSHowBack isEnableAdd />
      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={employeeList}
          params={pageState}
          isCanShow={() => true}
          isCanDelete={() => true}
          isCanEdit={() => true}
          onAction={onActionClick}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>
    </div>
  );
};
